<div class="footer">
  <div class="footer-content">
    <div class="newsletter">
      <img class="logo-footer" src="/images/logo-v2.png" alt="WealthLane Logo">
      <h2 class="newsletter-title">S’inscrire à la newsletter</h2>
      <input type="email" placeholder="Votre email...">
      <button>S’inscrire gratuitement</button>
      <p class="newsletter-text">Nous utilisons votre email uniquement pour notre newsletter. Consultez notre
        <a>politique de
          confidentialité</a>.</p>
    </div>
    <div class="links">
      <div class="link-column">
        <h3>Solutions</h3>
        <ul>
          <li>Solutions</li>
          <li>Solutions</li>
          <li>Solutions</li>
        </ul>
      </div>
      <div class="link-column">
        <h3>Ressources</h3>
        <ul>
          <li>Ressources</li>
          <li>Ressources</li>
          <li>Ressources</li>
        </ul>
      </div>
      <div class="link-column">
        <h3>À propos</h3>
        <ul>
          <li>À propos</li>
          <li>À propos</li>
          <li>À propos</li>
        </ul>
      </div>
      <div class="link-column">
        <h3>Nous contacter</h3>
        <ul>
          <li>Nous contacter</li>
          <li>Nous contacter</li>
          <li>Nous contacter</li>
        </ul>
      </div>
    </div>
  </div>
</div>